import axios from 'axios';

// Używamy window.location.hostname, żeby działało zarówno na localhost jak i na IP
const baseURL = `http://${window.location.hostname}:8000`;

console.log('Axios baseURL:', baseURL); // Dodajemy log dla debugowania

const instance = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  timeout: 5000 // Dodajemy timeout
});

// Dodaj token do każdego requestu
instance.interceptors.request.use(
  (config) => {
    console.log('Sending request to:', `${baseURL}${config.url}`); // Log dla debugowania
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('Request error:', error); // Log dla debugowania
    return Promise.reject(error);
  }
);

// Obsługa błędów autoryzacji
instance.interceptors.response.use(
  (response) => {
    console.log('Response received:', response.status, response.data); // Log dla debugowania
    return response;
  },
  (error) => {
    console.error('Response error:', error); // Log dla debugowania
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export { baseURL };
export default instance;
